import React from 'react'
import { NavWrapper } from '../Nav/NavWrapper'
import { NavClient } from './index.client'

export const baseClass = 'nav'

export const CustomAfterNav = () => {
  const groups = [
    {
      entities: [
        {
          slug: 'account',
          type: 'MANAGE ACCOUNT',
          label: {
            en: 'My Profile',
            fr: 'Mon Profil',
            ar: 'حسابي',
          }
        },
        {
          slug: 'logout',
          type: 'MANAGE ACCOUNT',
          label: {
            en: 'Logout',
            fr: 'Se déconnecter',
            ar: 'تسجيل الخروج',
          },
        },
      ],
      label: {
        en: 'Manage Account',
        fr: 'Gérer le compte',
        ar: 'إدارة الحساب',
      },
    },
  ]
  const navPreferences = {
    open: true,
    groups: {
      'My Profile': {
        open: true,
      },
    },
  }
  return (
    <nav className={`${baseClass}__wrap`}>
      <NavClient groups={groups} navPreferences={navPreferences} />
    </nav>
  )
}
